import React from "react";
import CustomCard from "../../../shared/Card/CustomCard";
import PrimaryButton from "../../../shared/Button/PrimaryButton";
import Index from "./index";
import { CustomInput } from "../../../shared/Input/AllInputs";
import { CustomEditor } from "../../../shared/Input/CustomEditor";

export default function PrivacyPolicy() {
    let { privacyPolicyData, setPrivacyPolicyData, updatePrivacyPolicyData } = Index();

    return (
        <CustomCard title={"Privacy Policy"} backable={false}>
            <CustomInput
                key="heading"
                label="Header"
                name="heading"
                data={privacyPolicyData}
                onChange={(e) => setPrivacyPolicyData((prev) => ({ ...prev, heading: e?.target?.value }))}
            />
            <CustomEditor
                name="paragraphText"
                label="Privacy policy"
                value={privacyPolicyData?.paragraphText}
                onTextChange={(e) => setPrivacyPolicyData((prev) => ({ ...prev, paragraphText: e?.htmlValue }))}
                style={{ height: "320px" }}
            />
            <div className="flex justify-content-end">
                <PrimaryButton label={"Update"} extraClassName={"w-3"} onClick={updatePrivacyPolicyData} />
            </div>
        </CustomCard>
    );
}
